export const CURRENT_TAB_PARAM = 'currentTab';
